/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _toConsumableArray } from '../_chunks/dep-fd3498b6.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { useState, Fragment } from 'react';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { Tag } from '../tag/index.js';
import useConfig from '../hooks/useConfig.js';
import useControlled from '../hooks/useControlled.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../tag/Tag.js';
import '../_chunks/dep-92728dc5.js';
import 'classnames';
import 'tdesign-icons-react';
import '../_util/noop.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../hooks/useGlobalIcon.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../tag/style/css.js';
import '../tag/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useTagList(props) {
  var _useConfig = useConfig(),
    prefix = _useConfig.classPrefix;
  var onRemove = props.onRemove,
    max = props.max,
    minCollapsedNum = props.minCollapsedNum,
    size = props.size,
    disabled = props.disabled,
    readonly = props.readonly,
    tagProps = props.tagProps,
    tag = props.tag,
    collapsedItems = props.collapsedItems,
    getDragProps = props.getDragProps;
  var _useControlled = useControlled(props, "value", props.onChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    tagValue = _useControlled2[0],
    setTagValue = _useControlled2[1];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    oldInputValue = _useState2[0],
    setOldInputValue = _useState2[1];
  var _onClose = function onClose(p) {
    var arr = _toConsumableArray(tagValue);
    arr.splice(p.index, 1);
    setTagValue(arr, _objectSpread({
      trigger: "tag-remove"
    }, p));
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(_objectSpread(_objectSpread({}, p), {}, {
      trigger: "tag-remove",
      value: arr
    }));
  };
  var clearAll = function clearAll(context) {
    setTagValue([], {
      trigger: "clear",
      e: context.e
    });
  };
  var onInnerEnter = function onInnerEnter(value, context) {
    var _props$onEnter;
    var valueStr = value ? String(value).trim() : "";
    var newValue = tagValue;
    var isLimitExceeded = max && (tagValue === null || tagValue === void 0 ? void 0 : tagValue.length) >= max;
    if (valueStr && !isLimitExceeded) {
      newValue = tagValue instanceof Array ? tagValue.concat(String(valueStr)) : [valueStr];
      setTagValue(newValue, {
        trigger: "enter",
        index: newValue.length - 1,
        item: valueStr,
        e: context.e
      });
    }
    props === null || props === void 0 ? void 0 : (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 ? void 0 : _props$onEnter.call(props, newValue, _objectSpread(_objectSpread({}, context), {}, {
      inputValue: value
    }));
  };
  var onInputBackspaceKeyUp = function onInputBackspaceKeyUp(value, context) {
    var e = context.e;
    if (!tagValue || !tagValue.length) return;
    if (!oldInputValue && ["Backspace", "NumpadDelete"].includes(e.key)) {
      var index = tagValue.length - 1;
      var item = tagValue[index];
      var trigger = "backspace";
      var newValue = tagValue.slice(0, -1);
      setTagValue(newValue, {
        e: e,
        index: index,
        item: item,
        trigger: trigger
      });
      onRemove === null || onRemove === void 0 ? void 0 : onRemove({
        e: e,
        index: index,
        item: item,
        trigger: trigger,
        value: newValue
      });
    }
    setOldInputValue(value);
  };
  var renderLabel = function renderLabel(_ref) {
    var displayNode = _ref.displayNode,
      label = _ref.label;
    var newList = minCollapsedNum ? tagValue.slice(0, minCollapsedNum) : tagValue;
    var list = displayNode ? [/* @__PURE__ */React.createElement(Fragment, {
      key: "display-node"
    }, displayNode)] : newList === null || newList === void 0 ? void 0 : newList.map(function (item, index) {
      var tagContent = isFunction_1(tag) ? tag({
        value: item
      }) : tag;
      return /* @__PURE__ */React.createElement(Tag, _objectSpread(_objectSpread({
        key: index,
        size: size,
        disabled: disabled,
        onClose: function onClose(context) {
          return _onClose({
            e: context.e,
            item: item,
            index: index
          });
        },
        closable: !readonly && !disabled
      }, getDragProps === null || getDragProps === void 0 ? void 0 : getDragProps(index, item)), tagProps), tagContent !== null && tagContent !== void 0 ? tagContent : item);
    });
    if (label) {
      list === null || list === void 0 ? void 0 : list.unshift( /* @__PURE__ */React.createElement("div", {
        className: "".concat(prefix, "-tag-input__prefix"),
        key: "label"
      }, label));
    }
    if (newList.length !== tagValue.length) {
      var len = tagValue.length - newList.length;
      var params = {
        value: tagValue,
        count: tagValue.length - minCollapsedNum,
        collapsedTags: tagValue.slice(minCollapsedNum, tagValue.length)
      };
      var more = isFunction_1(collapsedItems) ? collapsedItems(params) : collapsedItems;
      list.push( /* @__PURE__ */React.createElement(Fragment, {
        key: "more"
      }, more !== null && more !== void 0 ? more : /* @__PURE__ */React.createElement(Tag, null, "+", len)));
    }
    return list;
  };
  return {
    tagValue: tagValue,
    clearAll: clearAll,
    onClose: _onClose,
    onInnerEnter: onInnerEnter,
    onInputBackspaceKeyUp: onInputBackspaceKeyUp,
    renderLabel: renderLabel
  };
}

export { useTagList as default };
//# sourceMappingURL=useTagList.js.map
